import {Deserializable} from "./deserializable.model";

export class JobServiceRule {

    // :; A service rule is assocuated with document types.

job_service_rule_id: number;

job_service_rule_name: string;
job_service_rule_description: string;
is_active: string;
job_service_rule_time_frame: string;

job_type_document_type_id: number;
job_type_location_id: number;
job_type_id: number;
job_type_court_id: number;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobServiceRule {
    Object.assign(this, input);

    return this;
  }


}
